import { useTheme } from "styled-components";

export const SuccessFill18Icon = ({ ...props }) => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_45320_178463)">
        <path
          d="M9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5Z"
          fill={theme.colorSuccess}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0303 5.96967C13.3232 6.26256 13.3232 6.73744 13.0303 7.03033L8.53033 11.5303C8.23744 11.8232 7.76256 11.8232 7.46967 11.5303L5.46967 9.53033C5.17678 9.23744 5.17678 8.76256 5.46967 8.46967C5.76256 8.17678 6.23744 8.17678 6.53033 8.46967L8 9.93934L11.9697 5.96967C12.2626 5.67678 12.7374 5.67678 13.0303 5.96967Z"
          fill={theme.colorBackgroundTertiary}
        />
      </g>
      <defs>
        <clipPath id="clip0_45320_178463">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
